import { useEffect, useState, useRef } from 'react';
import LoyaltyService from 'common/services/loyalty-service';

const defaultLoyaltyInfo = {
  isLoading: true,
  loyaltySubscribedSites: [],
  loyaltyEligible: false,
  loyaltyCreditsPercent: 0,
};

const useLoyaltyInfo = () => {
  const loyaltyService = useRef(new LoyaltyService());

  const [loyaltyInfo, setLoyaltyInfo] = useState(defaultLoyaltyInfo);

  useEffect(() => {
    if (BC.user.isLoggedIn || BC.user.isRegistered) {
      loyaltyService.current.getCachedLoyaltyProgramInfo()
        .then((data) => {
          setLoyaltyInfo((current) => { return { ...current, ...data, isLoading: false }; });
        })
        .catch((err) => {
          setLoyaltyInfo((current) => { return { ...current, isLoading: false }; });
          $.error(`[use-loyalty-info] Error fetching loyalty data | error: ${err}`);
        });
    }
  }, []);

  return [loyaltyInfo];
};

export default useLoyaltyInfo;
